import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
    const { authTokens } = useContext(AuthContext);

    return authTokens ? children : <Navigate to="/auth" replace />;
};

export default PrivateRoute;